// extracted by mini-css-extract-plugin
module.exports = {"links":"CopyrightMenu_links___e2t0"};